import { Component, OnDestroy, TemplateRef } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

@UntilDestroy()
@Component({
    template: '',
    providers: [MatDialog],
    standalone: false
})
export abstract class SiModalOpenerComponent implements OnDestroy {
    private closed: boolean = false;
    private opened: boolean = false;
    private dialogId: string;
    constructor(
        protected readonly router: Router,
        private readonly dialog: MatDialog,
        private readonly route: ActivatedRoute,
    ) {
    }

    init<T, D>(content: ComponentType<T> | TemplateRef<T>, config: MatDialogConfig<D & { return?: { commands: any[], extras: NavigationExtras } }> = {}): void {
        setTimeout(() => {
            const { data, ...other } = config;
            const commands: any[] = data?.return?.commands;
            const extras: NavigationExtras = data?.return?.extras;

            this.dialogId = other.id || this.getUniqueId();

            const c: MatDialogConfig<D> = {
                ...other,
                id: this.dialogId,
                data,
            };
            this.opened = true;

            this.dialog.open(content, c).afterClosed()
                .pipe(untilDestroyed(this))
                .subscribe(() => {
                    this.closeDialog(commands, extras);
                });
        }, 0);
    }

    closeDialog(commands?: any[], extras?: NavigationExtras): void {
        const currentUrlTree = this.router.parseUrl(this.router.url);

        // 1. Get current outlet `modal` path segment
        const modalSegment = currentUrlTree.root.children['modal']?.segments?.[0]?.path;

        // 2. Extract queryParams and filter them
        const currentQueryParams = { ...this.route.snapshot.queryParams };

        const queryParams = Object.keys(currentQueryParams)
        .filter(key => !modalSegment || !key.startsWith(modalSegment))
        .reduce((acc, key) => {
            acc[key] = currentQueryParams[key];
            return acc;
        }, {} as Record<string, any>);

        this.closed = true;
        this.router.navigate(commands ? commands : ['', { outlets: { modal: null } }], extras ? extras : { queryParams });
    }

    ngOnDestroy(): void {
        if (this.opened && !this.closed) {
            this.dialog.getDialogById(this.dialogId)?.close();
        }
    }

    private getUniqueId(): string {
        return `modal-${Date.now()}`;
    }
}
